import { createContext, useContext, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./ActivityReportUIHelpers";

const ActivityReportUIContext = createContext();

export function useActivityReportUIContext() {
  return useContext(ActivityReportUIContext);
}

export const ActivityReportUIConsumer = ActivityReportUIContext.Consumer;

export function ActivityReportUIProvider({ activityReportUIEvents, children }) {
  const { user } = useSelector(state => state.auth);
  initialFilter.term = user.currentActiveTerm; // Mevcut Aktif Dönem Atanıyor
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openExplanationModal: activityReportUIEvents.openExplanationModal
  };

  return (
    <ActivityReportUIContext.Provider value={value}>
      {children}
    </ActivityReportUIContext.Provider>
  );
}